export default "__VITE_ASSET__D_3zc2MR__"